import { render, staticRenderFns } from "./ManageText.vue?vue&type=template&id=28dcfad9&scoped=true"
import script from "./ManageText.vue?vue&type=script&lang=js"
export * from "./ManageText.vue?vue&type=script&lang=js"
import style0 from "./ManageText.vue?vue&type=style&index=0&id=28dcfad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dcfad9",
  null
  
)

export default component.exports